export default __webpack_public_path__ + "static/media/minus_blue.0dd5a23d.svg";